module.exports = __webpack_public_path__ + "a2862bf26201711f4ba437afe696f06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-nonprofit.jpg
// module id = 122
// module chunks = 0